import api from '@pray/shared/utils/api';
import type { ObjectResponse } from '@pray/shared/utils/api/types/response';

import type { MemberResponse, UpdateMemberParams, UpdateMemberRequest } from './types';

function mapParamsToRequest(params: UpdateMemberParams): UpdateMemberRequest {
  /* eslint-disable camelcase */
  const request: UpdateMemberRequest = {};

  if (params.name !== undefined) request.name = params.name;
  if (params.firstName !== undefined) request.first_name = params.firstName;
  if (params.lastName !== undefined) request.last_name = params.lastName;
  if (params.email !== undefined) request.email = params.email;
  if (params.phone !== undefined) request.phone = params.phone;
  if (params.countryCode !== undefined) request.country_code = params.countryCode;
  if (params.profileImage !== undefined) request.profile_image = params.profileImage;
  if (params.bio !== undefined) request.bio = params.bio;
  if (params.city !== undefined) request.city = params.city;
  if (params.state !== undefined) request.state = params.state;
  if (params.country !== undefined) request.country = params.country;
  if (params.zipcode !== undefined) request.zipcode = params.zipcode;
  if (params.gender !== undefined) request.gender = params.gender;
  if (params.birthday !== undefined) request.birthday = params.birthday;
  if (params.handle !== undefined) request.handle = params.handle;
  if (params.sms !== undefined) request.sms = params.sms;
  if (params.marketingSms !== undefined) request.marketing_sms = params.marketingSms;
  if (params.emailVerified !== undefined) request.email_verified = params.emailVerified;

  return request;
  /* eslint-enable camelcase */
}

export async function updateMember(memberId: string, params: UpdateMemberParams) {
  const url = `/web/studio/users/${memberId}`;
  const requestBody = mapParamsToRequest(params);

  const response = await api.executePutRequest<ObjectResponse<MemberResponse>>(url, requestBody);

  return response.data;
}
